import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { logoutService, getUserDetails, getUserRoleType, getUserName } from "../../services/aws/aws-services";
import IdleTimer from "react-idle-timer";
import { checkLocalStorage, checkSessionStorage, clearLocalStorage, clearSessionStorage, getLocalStorage, removeSessionStorage } from '../../services/storage/storage-service';
import { logger } from '../../services/logger/logger-service';
import { loggerEventOutcome, loggerEventTypes, loggerEventName, loggerEventMessage } from '../../helpers/messages';
import { getImgSrc, getTokenFromCallbackURL, isFederatedLogin } from '../../helpers/GlobalFunctions';
import environment from '../../config/environment';
import { RolePermission, Roles } from '../../helpers/constants';
import { RoutesPerModule, RoutesSlugs } from '../../constants/definedRoutes/definedRoutes';
import { Hub } from 'aws-amplify';

class Sidemenu extends Component {
	constructor(props) {
		super(props);
		const { pathname } = props.location;
		const getUserDetail = getUserDetails();
		const userName = getUserName();
		const loggedInUserType = getUserRoleType();
		this.state = {
			userDetails: getUserDetail,
			firstName: getUserDetail ? getUserDetail.given_name : "",
			lastName: getUserDetail ? getUserDetail.family_name : "",
			userName: userName,
			remaining: this.timeout,
			isIdle: false,
			lastActive: new Date(),
			elapsed: 0,
			navSelected: pathname,
			loggedInUserType: loggedInUserType,
			loggingOut: false,
			isFederatedLogin: isFederatedLogin()
		};

		this.idleTimer = null;
		this.timeout = 1000 * 60 * 10; // 10 minute timeout

		this.handleOnAction = this.handleOnAction.bind(this);
		this.handleOnActive = this.handleOnActive.bind(this);
		this.handleOnIdle = this.handleOnIdle.bind(this);
		Hub.listen("auth", ({ payload: { event, data } }) => {
			switch (event) {
				case "oAuthSignOut":
					clearSessionStorage();
					clearLocalStorage();
					// window.location = '/login';
					break;

				default:
					break;
			}
		});
	}

	// clear session on page reopen using ctrl+shfit+t
	/* istanbul ignore next */
	resetSessionOnTabReopen() {
		if (this.state.firstName && performance && performance.getEntriesByType) {
			var perfEntries = performance.getEntriesByType("navigation");
			for (var i = 0; i < perfEntries.length; i++) {
				var p = perfEntries[i];
				if (p.type === "back_forward") {
					removeSessionStorage('useractivestatus');
				}
			}
		}
	}

	/* istanbul ignore next */
	componentDidMount() {
		if (!this.props?.location?.hash) {
			this.resetSessionOnTabReopen();
			if (!checkSessionStorage("useractivestatus") && !this.state.loggingOut) {
				this.logout();
			}
		}

		this.setState({
			remaining: this.idleTimer.getRemainingTime(),
			lastActive: this.idleTimer.getLastActiveTime(),
			elapsed: this.idleTimer.getElapsedTime(),
		});

		this.timer = setInterval(() => {
			this.setState({
				remaining: this.idleTimer.getRemainingTime(),
				lastActive: this.idleTimer.getLastActiveTime(),
				elapsed: this.idleTimer.getElapsedTime(),
			});
		}, 1000);
	}

	componentDidUpdate() {
		/* istanbul ignore next */
		if (this.props.uploadProgress && !isNaN(parseInt(this.props.uploadProgress)) && this.props.uploadProgress < 100) {
			this.idleTimer.pause();
		} else {
			this.idleTimer.resume();
		}
	}

	async applicationLogger(key) {
		const loggerObj = {
			"EventOutcome": loggerEventOutcome.success,
			"EventType": loggerEventTypes.logout,
			"EventName": loggerEventName.logout,
			"Content": {
				"Data": loggerEventMessage.logout
			}
		}
		await logger(loggerObj);
	}

	// logs are tracked in logout if logs not tracked in component will unmount
	/* istanbul ignore next  */
	async currentPageLogger() {
		if (this.props.loggerObj) {
			const timeSinceLoad = (new Date().getTime() - this.props.loggerObj.StartDate.getTime()) / 1000;
			const loggerObj = {
				"EventOutcome": this.props.loggerObj.EventOutcome,
				"EventType": this.props.loggerObj.EventType,
				"EventName": this.props.loggerObj.EventName,
				"Content": {
					"TimeSpent": timeSinceLoad
				}
			}
			await logger(loggerObj);
		}
	}

	// What to do when there is user interaction
	/* istanbul ignore next */
	handleOnAction(event) {
		if (!localStorage.getItem('cognito_data') && !this.state.loggingOut && !getTokenFromCallbackURL()) {
			this.logout();
		} else {
			/* istanbul ignore next */
			const userName = getUserName();
			if (this.state.userName !== userName) {
				const getUserDetail = getUserDetails();
				this.setState({
					firstName: getUserDetail ? getUserDetail.given_name : "",
					lastName: getUserDetail ? getUserDetail.family_name : "",
					userName: userName,
					userDetails: getUserDetail
				})
			}
		}
	}

	// What to do when the user hasn't done anything in 10 min
	/* istanbul ignore next */
	handleOnIdle(event) {
		if (!this.state.loggingOut) {
			this.logout();
		}
	}

	// What to do when the user go from idle to active; doesn't apply here
	/* istanbul ignore next */
	handleOnActive(event) { }

	/* istanbul ignore next  */
	componentWillUnmount() {
		clearInterval(this.timer);
	}

	/**
	 * @description function to handle logout functionality
	 * @param {*}
	 * @memberof Header
	 */
	/* istanbul ignore next  */
	logout = (e) => {
		if (e) {
			e.preventDefault();
			this.setState({ loggingOut: true });
		}
		Promise.all([
			this.currentPageLogger(),
			this.applicationLogger()
		]).then((res) => {
			// setTimeout(() => {
			logoutService((err, resp) => { });
			// }, 500);
		}).catch(err => {
			console.log('Error logging out: ', err);
		});
	};

	/**
	 * @description function to handle user's role display
	 * @param {*}
	 * @memberof Sidemenu
	 */
	getRoleNames = () => {
		const { loggedInUserType } = this.state;
		if (!loggedInUserType) {
			return '';
		}
		var rolesText = '';
		let role = Roles.find(x => x.userRole === loggedInUserType);
		rolesText = role ? role.label : '';

		return rolesText;
	}

	/**
	 * @description function to handle AD user's SN job title display
	 * @param {*}
	 * @memberof Sidemenu
	 */
	getSNJobTitle = () => {
		const { userDetails } = this.state;
		return userDetails ? userDetails['custom:Jobrole'] : ''

	}

	/**
	 * @description function to handle AD user's SN user role display
	 * @param {*}
	 * @memberof Sidemenu
	 */
	getSNUserRole = () => {
		const roleObj = checkLocalStorage('ADUserRoleObj') ? JSON.parse(getLocalStorage('ADUserRoleObj')) : null;
		return roleObj ? roleObj.roleDisplayName : 'N/A'
	}

	/**
	 * @description function to handle user's name display
	 * @param {*}
	 * @memberof Header
	 */
	/* istanbul ignore next  */
	getUserName = (name) => {
		return name?.length > 20 ? `${name.substring(0, 20)}...` : name;
	}

	render() {
		const { hideMenu } = this.props;
		const { firstName, lastName, loggedInUserType, navSelected, isFederatedLogin } = this.state;

		return (
			<div className="sidemenu-wrap" data-testid="sidemenu-wrap">
				<IdleTimer
					ref={(ref) => { this.idleTimer = ref; }}
					timeout={this.timeout}
					onActive={this.handleOnActive}
					onIdle={this.handleOnIdle}
					onAction={this.handleOnAction}
				/>
				<div className="sidenav-profile">
					<div className="logo-img-wrap">
						<img className="w-100" src={getImgSrc('DAP_BrandLogo.svg')} alt="Logo - Digital Asset Portal" />
					</div>
					<div className="surgeon-info text-center">
						<div className="profile mb-3">
							<img src={getImgSrc('no-profile-image.png')} alt="Profile" />
						</div>
						<span className="d-block user-name" title={`${firstName} ${lastName}`}>{this.getUserName(`${firstName} ${lastName}`)}</span>
						<span className="d-block role-info fs-8-rem">{isFederatedLogin ? this.getSNUserRole() : this.getRoleNames()}</span>
					</div>
					<div className="logout">
						<div id="logout" className="logout-text cursor-pointer" onClick={this.logout} title="Log out">
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-box-arrow-right" viewBox="0 0 16 16">
								<path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z" />
								<path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z" />
							</svg>
							<span>Logout</span>
						</div>
					</div>
				</div>
				<div id="mySidenav" className="sidenav">
					{hideMenu ? '' :
						<nav>
							<ul>
								{/* Dashboard */}
								{RolePermission.dashboard.indexOf(loggedInUserType) > -1 ?
									<li className={RoutesPerModule.dashboard.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.dashboard.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('Dashboard.svg')} alt="Dashboard" />
										<Link to={RoutesSlugs.dashboard} style={{ margin: 'auto', height: 60 }}>Dashboard</Link>
									</li>
									: null}

								{/* Digital Assets List */}
								{RolePermission.fileUpload.indexOf(loggedInUserType) > -1 ?
									<li className={RoutesPerModule.assets.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.assets.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('DigitalAssets.svg')} alt="Digital Assets" />
										<Link to={RoutesSlugs.assets.list} style={{ margin: 'auto', height: 60 }}>Digital Assets</Link>
									</li>
									: null}

								{/* Regions */}
								{RolePermission.region.indexOf(loggedInUserType) > -1 ?
									<li className={RoutesPerModule.regions.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.regions.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('Region.svg')} alt="Regions" />
										<Link to={RoutesSlugs.regions.list} style={{ margin: 'auto', height: 60 }}>Regions</Link>
									</li>
									: null}

								{/* Device list link */}
								{RolePermission.deviceList.indexOf(loggedInUserType) > -1 ?
									<li className={RoutesPerModule.devices.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.devices.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('DeviceList.svg')} alt="calculator" />
										<Link to={RoutesSlugs.devices.list} style={{ margin: 'auto', height: 60 }}>CORI-XT Devices</Link>
									</li> : ''}

								{/* User Management */}
								{RolePermission.userManagement.indexOf(loggedInUserType) > -1 ?
									<li className={RoutesPerModule.users.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.users.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('Users.svg')} alt="Users" />
										<Link to={RoutesSlugs.users.list} style={{ margin: 'auto', height: 60 }}>Users</Link>
									</li> : ''}
								

								{/* System Logs */}
								{RolePermission.systemLogs.indexOf(loggedInUserType) > -1 ?
									<li className={RoutesPerModule.systemLogs.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.systemLogs.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('SystemLogs.svg')} alt="System Logs" />
										<Link to={RoutesSlugs.systemLogs} style={{ margin: 'auto', height: 60 }}>System Logs</Link>
									</li>
									: null}

								{/* Audit Logs */}
								{RolePermission.auditLogs.indexOf(loggedInUserType) > -1 ?
									<li className={RoutesPerModule.auditLogs.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.auditLogs.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('AuditLogs.svg')} alt="Audit Logs" />
										<Link to={RoutesSlugs.auditLogs} style={{ margin: 'auto', height: 60 }}>Audit Logs</Link>
									</li>
									: ''}

								{/* Settings */}
								{RolePermission.settings.indexOf(loggedInUserType) > -1 && !isFederatedLogin ?
									<li className={RoutesPerModule.settings.indexOf(navSelected) > -1 ? 'slctd' : ''}>
										<img className={RoutesPerModule.settings.indexOf(navSelected) > -1 ? 'filter-white' : 'filter-black'} src={getImgSrc('Settings.svg')} alt="Settings" />
										<Link to={RoutesSlugs.settings} style={{ margin: 'auto', height: 'auto' }}>Settings</Link>
									</li>
									: ''}
							</ul>
						</nav>
					}
				</div>
				<div className="sn-bottom-logo">
					{/* <img src={getImgSrc('sn-bottom-logo.png')} alt="sn-bottom-logo" /> */}
					<p className="text-muted mt-2 fs-8-rem">App Version: {environment.appVersion}</p>
				</div>
			</div>
		)
	}
}

export default withRouter(props => <Sidemenu {...props} />);
